module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-BlackItalic.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-BlackItalic.woff
 ** module id = 1102
 ** module chunks = 0
 **/